export { default } from './svg/giphy.svg';
